module.exports = __webpack_public_path__ + "src/assets/textures/tractor/label.png";